import React from "react";

const Concept = () => {
  return (
    <div>
      <p className="step-p">
        If a participant has more than 51% of the network, he could out-mine the
        network and hack the blockchain.
      </p>

      <p>
        When there are more miners in the network, the processing power becomes
        more distributed and no one has majority power. This leads to a more
        secure blockchain.
      </p>
    </div>
  );
};

export default Concept;



// WEBPACK FOOTER //
// ./src/steps/51-attack/concept.js